import { Route, Routes, useLocation } from "react-router-dom";
import { Fragment, useEffect, useContext } from "react";
import Navbar from "./Navigation/Navbar";
import Home from "./Routes/Home/Home";
import About from "./Routes/About/about_us";
import ContactUs from "./Conatct_us/contact_us.jsx";
import Newsinsignt from "./Routes/Newinsight/news";
import Eagle from "./Routes/Our_Eagle/edge";
import Explore from "./Routes/Explore/expolore";
import Tugboat from "./Routes/Tugboat/Tugboat";
import Signup from "./Auth/Signup/Signup";
import Login from "./Auth/Login/Login";
import Footer from "./Footer/Footer";
import TugboatDeatails from "./Routes/TugBoatsDetails/Tugboatsdeatails";
import { AuthContext } from "./Context/AuthContext";
import Acountverification from "./Auth/Accverification/Accountverification.jsx";
import Forgotpassword from "./Auth/Forgotpassword/Forgotpassword";
import Resetpassword from "./Auth/Resetpassword/Resetpassword";
import ChooseAccount from "./Routes/ChooseAc/chooseAcount";
import AuthLogin from "./Routes/choose_login/auth.jsx"
import NotFound from "./Notfound/Notfound";
import Customeractivationpage1 from "./Charterer/CusstomerActivation/Customeractivation.jsx";
import Customeractivepage2 from "./Charterer/CusstomerActivation/Customeractivepage2.jsx";
import Updatecustomerpass from "./Auth/Updatepassord/Updatecustomerpass.jsx"
import UpdatecustomerProfile from "./Charterer/CustomerProfile/Updatecustomer/UpdatecustomerProfile.jsx";
import PassswordResetSuccess from "./Auth/Passwordsuccess/passwordsuccess.jsx";
import StatutoryDocs from "./Charterer/statutoryDocs/statutorydocs.jsx";
import Licenses from "./Charterer/licenseDocs/license.jsx";
import OtherDocs from "./Charterer/OtherDocs/otherdocs.jsx";
import Comfirmation from "./Charterer/comfirmation/comfirmation.jsx";
import UpdateDocs from "./Charterer/update/updatedocs/updatedocs.jsx";
import UpdateLicenses from "./Charterer/update/updatelicenses/updatelicenses.jsx";
import UpdateOtherDocs from "./Charterer/update/updateotherdocs/updateotherdocs.jsx";
import VerifyConfirmation from "./Charterer/verifyconfirmation/verifyconfirmation.jsx";
import TypeOfUpdate from "./Charterer/update/chosekindofupdate/typeofupdate.jsx";
import MobileProfile from "./Charterer/pages/mobile/mobileprofile.jsx";
import ViewOtherLicenses from "./Charterer/Viewdocuploaded/viewotherlicenses/viewotherlicenses.jsx";
import ViewOtherDocs from "./Charterer/Viewdocuploaded/viewotherdocs/viewotherdocs.jsx";
import CreateProfileStepOne from "./vesselOwner/createProfile/step_1/createprofile_step_1.jsx";
import CreateProfleStepTwo from "./vesselOwner/createProfile/createprofile_step_2.jsx";
import VesselOwnerProfile from "./vesselOwner/getprofile/profile_v.jsx";
import UpdateVesselOwnerPass from "./vesselOwner/updatevpass/updatevpass.jsx";
import VesselOwnerStatutoryDoc from "./vesselOwner/statutory_v_doc/statutory_v_doc.jsx";
import VesselOwnerLicenses from "./vesselOwner/licenses/licenses_v.jsx";
import VesselOwnerOtherDocs from "./vesselOwner/otherdocs_v/otherdocs_v.jsx";
import UpdatesVesselOwner from "./vesselOwner/Update/updates/updates.jsx";
import UpdateStatutoryDoc from "./vesselOwner/Update/updatesdoc/updatestatutorydoc.jsx";
import UpdateVesselOwnerLicenses from "./vesselOwner/Update/updatesdoc/updatelicenses.jsx";
import UpdateVesselOwnerOtherDocs from "./vesselOwner/Update/updatesdoc/updateotherdocs.jsx";
import MobileProfileV from "./vesselOwner/mobile/mobile_v.jsx";
import CreateVessel from "./vesselsOnbording/create_vessels/create_vessel.jsx";
import VesselInfomation from "./vesselsOnbording/vessetype/vessel_infomation.jsx";
import Vesselgeneralinformation from "./vesselsOnbording/vessetype/vessel_general_information.jsx";
import VesselImages from "./vesselsOnbording/vesselimages/vesselimages.jsx";
import VessselPrimaryDoc from "./vesselsOnbording/vesselprimarydoc/veseelprimarydoc.jsx";
import VesselOtherDocs from "./vesselsOnbording/vesselotherdoc/vesselotherdocs.jsx";
import MyVesselss from "./myvessels/myvessel/myvessels.jsx";
import VesselDetails from "./myvessels/vesseldetails/vesseldetails.jsx";
import AllpendingUpdates from "./myvessels/pendingupdate/allpendingupdate.jsx";
import Notifications from "./socket/Notifications/notifications";
import NotificationDetails from "./socket/Notifications-details/notiffaction_details.jsx";
import Skip from "./skip/skip.jsx";
import DoubleCheck from "./Auth/double-email/double_emil/double_check.jsx";
import DoubleCheckConfirmation from "./Auth/double-email/double_check_confirmation/check_confirmation.jsx";
import OurVessels from "./Charterer/our_vessels/ourvessels.jsx";
import StaeHolders from "./Routes/stake_holder/stake_holders.jsx";
import Faqs from "./Routes/faqs/faqs.jsx";
import VesselAgreement from "./vesselOwner/veselOwneragreement/vesselagreement.jsx";
import Jobs from "./Routes/jobs/jobs.jsx";
import VcontactPerson from "./vesselOwner/v_contact_person/v_contact_person.jsx"
import ChartererContactPerson from "./Charterer/contactPerson/charterer_contact_person.jsx"
import Dashboard from "./vesselOwner/dashboard/dashboard.jsx";
import DashboardHome from "./vesselOwner/dashboard/DashboardHome.jsx";
import CharterRequests from "./vesselOwner/charterRequests/CharterRequests.jsx";
import Haggling from "./vesselOwner/haggling/Haggling.jsx";
import Bidding from "./vesselOwner/haggling/Bidding.jsx";
import VesselFinancing from "./Routes/Vessel Financing/vessel_financing.jsx";
// Charterer Dashboard imports
import ChartererDashboard from "./Charterer/dashboard/dashboard.jsx";
import ChartererDashboardHome from "./Charterer/dashboard/DashboardHome.jsx";
import MyCharters from "./Charterer/dashboard/MyCharters.jsx";
import ActiveVessels from "./Charterer/dashboard/ActiveVessels.jsx";
import OngoingProcess from "./Charterer/dashboard/OngoingProcess.jsx";






const App = () => {
  const { isAuthenticated, role, token } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const pathsWithoutNavbarAndFooter = [
    "/Login", "/Signup", "/Forgotpassword", "/Resetpassword",
    "/Acountverification", "/ChooseAccount", "/Customeractivationpage1",
    "/Customeractivepage2",
    "/Loginaddmin", "/Forgotaddminpassword",
    "/passwordsuccess", "/statutorydocs", "/license", "/otherdocs",
    "/comfirmation", "/updatedocs", "/updatelicense", "/updateotherdocs",
    "/verifyconfirmation", "/createprofile_step_1", "/createprofile_step_2",
    "/statutory_v_doc", "/licenses_v", "/otherdocs_v", "/updatestatutorydoc",
    "/updatelicenses", "/updateotherdocs", "/create_vessel", "/vessel_infomation",
    "/vessel_general_information", "/vesselimages", "/veseelprimarydoc",
    "/vesselotherdocs", "/vesselagreement", "/v_contact_person", "/charterer_contact_person",
    "/dashboard", "/dashboard/myvessels", "/dashboard/charter-requests", "/dashboard/haggling", "/dashboard/haggling/bidding", 
    "/dashboard/profile_v", "/dashboard/updates", "/dashboard/updatevpass",
    "/charterer-dashboard", "/charterer-dashboard/vessels", "/charterer-dashboard/my-charters", "/charterer-dashboard/haggling",
    "/charterer-dashboard/active-vessels", "/charterer-dashboard/ongoing-process",
    "/charterer-dashboard/updatecustomerprofile", "/charterer-dashboard/updatecustomerpass", "/charterer-dashboard/typeofupdate", 
    "/charterer-dashboard/notifications"
  ];

  const isSpecialPath = pathsWithoutNavbarAndFooter.includes(location.pathname);

  return (
    <Fragment>
      <Routes>
        <Route
          path="/"
          element={
            !isSpecialPath && <Navbar />
          }
        >
          <Route index element={<Home />} />
          <Route path="/about_us" element={<About />} />
          <Route path="/news" element={<Newsinsignt />} />
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/edge" element={<Eagle />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/Tugboat" element={<Tugboat />} />
          <Route path="/Tugdetails/:id" element={<TugboatDeatails />} />      
          <Route path="/our_vessels" element={<OurVessels />} />      
          <Route path="/stake_holder" element={<StaeHolders />} />      
          <Route path="/faqs" element={<Faqs />} />    
          <Route path="/jobs" element={<Jobs />} /> 
          <Route path="/vessel_financing" element={<VesselFinancing/>}/>
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {!isAuthenticated ? (
          <>
            <Route path="/AccountVerification" element={<Acountverification />} />
            <Route path="/Signup" element={<Signup />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/Forgotpassword" element={<Forgotpassword />} />
            <Route path="/Resetpassword" element={<Resetpassword />} />
            <Route path="/ChooseAccount" element={<ChooseAccount />} />
            <Route path="/choose_login" element={<AuthLogin />} />
            <Route path="/passwordsuccess" element={<PassswordResetSuccess />} />
            <Route path="/verifyconfirmation" element={<VerifyConfirmation />} />
            <Route path="/double_check" element={<DoubleCheck />} />
            <Route path="/check_confirmation" element={<DoubleCheckConfirmation />} />
          </>
        ) : role === 'charterer' && token ? (
           <>
            <Route path="/"  element={!isSpecialPath && <Navbar />}>
              <Route path="/Customeractivationpage1" element={<Customeractivationpage1 />} />
              <Route path="/Customeractivepage2" element={<Customeractivepage2 />} />
              <Route path="/Updatecustomerpass" element={<Updatecustomerpass />} />
              <Route path="/UpdatecustomerProfile" element={<UpdatecustomerProfile />} />
              <Route path="/statutorydocs" element={<StatutoryDocs />} />
              <Route path="/license" element={<Licenses />} />
              <Route path="/otherdocs" element={<OtherDocs />} />
              <Route path="/comfirmation" element={<Comfirmation />} />
              <Route path="/updatedocs" element={<UpdateDocs />} />
              <Route path="/updatelicense" element={<UpdateLicenses />} />
              <Route path="/updateotherdocs" element={<UpdateOtherDocs />} />
              <Route path="/charterer_contact_person" element={<ChartererContactPerson />} />
              <Route path="/typeofupdate" element={<TypeOfUpdate />} />
              <Route path="/mobileprofile" element={<MobileProfile />} />
              <Route path="/viewotherlicenses" element={<ViewOtherLicenses />} />
              <Route path="/viewotherdocs" element={<ViewOtherDocs />} />
              <Route path="/notifications" element={<Notifications/>}/>
              <Route path="/notification/:_id" element={<NotificationDetails/>}/>
              <Route path="/skip" element={<Skip />} />
            </Route>
            
            {/* Charterer Dashboard Routes */}
            <Route path="/charterer-dashboard/*" element={<ChartererDashboard />}> 
              <Route index element={<ChartererDashboardHome />} />
              <Route path="vessels" element={<OurVessels />} />
              <Route path="active-vessels" element={<ActiveVessels />} />
              <Route path="ongoing-process" element={<OngoingProcess />} />
              <Route path="haggling" element={<Haggling />} />
              <Route path="haggling/bidding" element={<Bidding />} />
              <Route path="notifications" element={<Notifications/>}/>
              <Route path="notification/:_id" element={<NotificationDetails/>}/>
              <Route path="updatecustomerprofile" element={<UpdatecustomerProfile/>}/>
              <Route path="updatecustomerpass" element={<Updatecustomerpass/>}/>
              <Route path="typeofupdate" element={<TypeOfUpdate />} />
              <Route path="my-charters" element={<MyCharters />} />
            </Route>
           </>
        ) : role === 'vesselOwner' && token ? (
            <>
              <Route path="/dashboard/*" element={<Dashboard />}> 
              <Route index element={<DashboardHome />} />
              <Route path="myvessels" element={<MyVesselss />} />
              <Route path="charter-requests" element={<CharterRequests />} />
              <Route path="haggling" element={<Haggling />} />
              <Route path="haggling/bidding" element={<Bidding />} />
              <Route path="mobile_v" element={<MobileProfileV/>} />
              <Route path="vessel/:id" element={<VesselDetails/>} />
              <Route path="allpendingupdate" element={<AllpendingUpdates/>} />
              <Route path="notifications" element={<Notifications/>}/>
              <Route path="notification/:_id" element={<NotificationDetails/>}/>
              <Route path="vesselagreement" element={<VesselAgreement />} />
              <Route path="skip" element={<Skip />} />
              <Route path="updates" element={<UpdatesVesselOwner />} />
              <Route path="updatevpass" element={<UpdateVesselOwnerPass/>}/>  
              <Route path="profile_v" element={<VesselOwnerProfile/>}/>
              </Route>
              <Route path="/createprofile_step_1" element={<CreateProfileStepOne/>}/>
              <Route path="/createprofile_step_2" element={<CreateProfleStepTwo/>}/>
              <Route path="/statutory_v_doc" element={<VesselOwnerStatutoryDoc/>}/>
              <Route path="/licenses_v" element={<VesselOwnerLicenses/>}/>
              <Route path="/otherdocs_v" element={<VesselOwnerOtherDocs/>}/>
              <Route path="/comfirmation" element={<Comfirmation />} />
              <Route path="/updatestatutorydoc" element={<UpdateStatutoryDoc />} />
              <Route path="/updatelicenses" element={<UpdateVesselOwnerLicenses />} />
              <Route path="/updateotherdocs" element={<UpdateVesselOwnerOtherDocs />} />
              <Route path="/v_contact_person" element={<VcontactPerson />} /> 
              <Route path="create_vessel" element={<CreateVessel/>} />
              <Route path="vessel_infomation" element={<VesselInfomation/>} />
              <Route path="vessel_general_information" element={<Vesselgeneralinformation/>} />
              <Route path="vesselimages" element={<VesselImages/>} />
              <Route path="veseelprimarydoc" element={<VessselPrimaryDoc/>} />
              <Route path="vesselotherdocs" element={<VesselOtherDocs/>} />
            </>
        ) : null}
      </Routes>
      {!isSpecialPath && <Footer />}
    </Fragment>
  );
};

export default App;
